import React, { useContext, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { Breadcrumb, Image, Toast } from "react-bootstrap";
import { get, find, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { InnerLayoutButtons } from "..";
import {
  manageCommunicationStore,
  setManageReportsFlow,
  setManageCommunicationToastInfo,
  getReportsDetailsAction,
} from "../../contexts";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import {
  MANAGE_REPORTS_ROUTES,
  ROUTES,
  manageReportsFormNames,
  apiErrors,
  getPathWithParam,
  ALL_MANAGE_REPORTS_ROUTES,
} from "../../utils";
import Cancel from "../../styles/cancel.png";

const ManageForfeitureLayout = ({
  pageName,
  children,
  buttons = [],
  pageFlow,
  layoutHeader,
  customBreadCrumbs,
  history,
}) => {
  const [showError, setShowError] = useState(false);
  const { state, dispatch } = useContext(manageCommunicationStore);
  //   const reportName = get(
  //     state,
  //     `${manageReportsFormNames.ELIGIBILITY_FILTER}.reportName`
  //   );
  //   const { reportId, flow } = useRouterParams();
  //   const { showToast, toastMessage } = { showToast: false, toastMessage: "" };

  const apiError = get(state, "api.error", {});
  //   const apiData = get(state, "api.data", {});

  //   const menuDetails = find(ALL_MANAGE_REPORTS_ROUTES, (item) => {
  //     if (get(state, "selectedMenu", "").indexOf(get(item, "path")) !== -1) {
  //       return true;
  //     }
  //     return false;
  //   });

  //   useDeepEffect(() => {
  //     if (isEmpty(apiData) && reportId) {
  //       dispatch(getReportsDetailsAction(reportId, dispatch, state));
  //       dispatch(setManageReportsFlow({ flow, reportId }));
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [reportId]);

  useDeepEffect(
    () => {
      if (!isEmpty(apiError)) {
        setShowError(true);
      }
    },
    [apiError],
    true
  );

  const breadCrumOptions = [
    {
      label: "Home",
      link: ROUTES.HOME,
    },
    {
      label: "Forfeiture",
      link: ROUTES.FORFEITURE,
    },
  ];

  //   if (reportName) {
  //     breadCrumOptions.push({
  //       label: reportName,
  //       link: getPathWithParam({
  //         path: MANAGE_REPORTS_ROUTES.ELIGIBILITY_FILTER,
  //         pathParam: [flow, reportId],
  //       }),
  //     });
  //   }

  if (!isEmpty(customBreadCrumbs)) {
    breadCrumOptions.push(...customBreadCrumbs);
  }
  //   const breadCrumbsFromMenuDetails = get(menuDetails, "breadCrumbs", []);
  //   if (!isEmpty(customBreadCrumbs)) {
  //     breadCrumOptions.push(...customBreadCrumbs);
  //   } else if (!isEmpty(breadCrumbsFromMenuDetails)) {
  //     breadCrumOptions.push(
  //       ...breadCrumbsFromMenuDetails.map((item) => ({
  //         ...item,
  //         link: getPathWithParam({
  //           path: item.link,
  //           pathParam: [flow, reportId],
  //         }),
  //       }))
  //     );
  //   }

  const errorStatus = get(apiError, "response.status", 500);
  const errorData = apiErrors[errorStatus];

  return (
    <div className="d-flex flex-column manage-report h-100">
      <div className="d-flex flex-column layout-header">
        <div className="d-flex align-items-center">
          <div>
            <Breadcrumb>
              {breadCrumOptions.slice(-4).map((item, index) => (
                <Breadcrumb.Item key={index}>
                  <Link to={item.link}>{item.label}</Link>
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
            <div className="title-case">{pageName}</div>
            <h5>{layoutHeader || ""}</h5>
          </div>
          <div className="ml-auto">
            <InnerLayoutButtons buttonsList={buttons} flow={pageFlow} />
          </div>
          {showError && (
            <div
              className={`error-banner justify-content-between d-flex align-items-center ${
                (showError && "enable") || ""
              }`}
            >
              <div>
                <Image src={Cancel} width="30px" />
              </div>
              <div>
                <div className="error-heading">{errorData.heading}</div>
                <div className="error-reason">{errorData.reason}</div>
              </div>
              <div>
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  color="#000"
                  style={{ fontSize: "14px" }}
                  onClick={() => setShowError(false)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="layout-content h-100 overflow-auto">{children}</div>
    </div>
  );
};

export default withRouter(ManageForfeitureLayout);
